import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { fetchJobs, fetchReportJobs } from "../../services/httpClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import html2canvas from "html2canvas";
import { JobsTable } from "./charts-metrics/JobsTable";

const Jobs = ({ buildPDF, canvas, setCanvas, iPad }: any) => {
  const [reportRunning, setReportRunning] = useState<boolean>(false);
  const [jobData, setJobData] = useState<any[]>([]);
  const [jobs, setJobs] = useState<any[]>([]);

  useEffect(() => {
    getJobData();
  }, []);

  const getJobData = () => {
    fetchReportJobs()
      .then((res: any) => {
        const reportJobs = res[0].data;
        setJobData(reportJobs);

        const deptCounts = reportJobs.reduce((acc: Record<string, number>, job: any) => {
          const dept = job.department;
          acc[dept] = (acc[dept] || 0) + 1;
          return acc;
        }, {});

        fetchJobs()
          .then((res: any) => {
            const jobs = res[0].data;
            const deptMap = new Map<string, any>();
            jobs.forEach((j: any) => {
              const deptName = j.department;
              const count = deptCounts[deptName] ?? 0;
              if (!deptMap.has(deptName)) {
                deptMap.set(deptName, { name: `${deptName} (${count})`, key: deptName, count });
              }
            });

            Object.entries(deptCounts).forEach(([dept, count]) => {
              const key = dept;
              if (!deptMap.has(key)) {
                deptMap.set(key, { name: `${key} (${count})`, key, count });
              } else {
                const existing = deptMap.get(key);
                existing.count = count;
                existing.name = `${key} (${count})`;
              }
            });

            const departments = Array.from(deptMap.values()).sort((a: any, b: any) => a.key.localeCompare(b.key));
            setJobs(departments);
          })
          .catch((err: any) => {
            console.log(err);
          });
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (reportRunning) {
      buildPDF();
      setReportRunning(false);
    }
  }, [canvas]);

  const downloadReport = async () => {
    setReportRunning(true);
    const reportSection = document.getElementById("jobs-section");
    const reportTitle = document.getElementById("jobs-title");
    const jobsFilters = document.getElementById("jobs-filters");
    const pagination = document.getElementById("jobs-pagination");

    if (reportSection) {
      if (reportTitle) {
        reportTitle.style.visibility = "hidden";
        reportTitle.style.display = "none";
      }

      if (jobsFilters) {
        jobsFilters.style.visibility = "hidden";
        jobsFilters.style.display = "none";
      }

      if (pagination) {
        pagination.style.visibility = "hidden";
        pagination.style.display = "none";
      }

      const images = reportSection.getElementsByTagName("img");
      for (let i = 0; i < images.length; i++) {
        images[i].crossOrigin = "anonymous";
      }

      const canvas = await html2canvas(reportSection, { useCORS: true });
      setCanvas(canvas);

      if (reportTitle) {
        reportTitle.style.visibility = "visible";
        reportTitle.style.display = "flex";
      }

      if (jobsFilters) {
        jobsFilters.style.visibility = "visible";
        jobsFilters.style.display = "flex";
      }

      if (pagination) {
        pagination.style.visibility = "visible";
        pagination.style.display = "flex";
      }
    } else {
      console.error("Report section not found");
      setReportRunning(false);
    }
  };

  return (
    <div id="jobs-section">
      <Row id="jobs-title" className="mb-3">
        <Col className="col-8">
          <h4 className="mb-0 app-header-text">Job Assignments</h4>
        </Col>
        <Col className="col-4 text-end">
          {!iPad && (
            <Button className="app-primary-color button" onClick={() => downloadReport()}>
              <FontAwesomeIcon icon={faDownload} />
              {" Report"}
            </Button>
          )}
        </Col>
      </Row>
      <JobsTable data={jobData} jobList={jobs} />
    </div>
  );
};

export default Jobs;
